import type React from "react";
import { memo } from "react";

const SEARCH_RESULT_HEADER_CLASS =
  "flex items-center justify-between px-1 py-1 animate-in fade-in slide-in-from-top-1 duration-200";
const SEARCH_RESULT_ROW_CLASS = "flex items-center gap-2 text-sm text-gray-600";
const SEARCH_RESULT_QUERY_CLASS = "font-medium";

export type SearchResultHeaderProps = {
  visible: boolean;
  queryText: string;
  resultLabel: string;
  resultCountLabel: string;
  noConditionText: string;
};

const SearchResultHeaderRaw: React.FC<SearchResultHeaderProps> = ({
  visible,
  queryText,
  resultLabel,
  resultCountLabel,
  noConditionText,
}) => {
  if (!visible) return null;

  return (
    <div className={SEARCH_RESULT_HEADER_CLASS}>
      <div className={SEARCH_RESULT_ROW_CLASS}>
        <span className="text-yellow-500">💡</span>
        <span className={SEARCH_RESULT_QUERY_CLASS}>
          {`"${queryText || noConditionText}"`}
        </span>
        <span>{resultLabel}</span>
        <span className="font-bold">{resultCountLabel}</span>
      </div>
    </div>
  );
};

export const SearchResultHeader = memo(SearchResultHeaderRaw);
SearchResultHeader.displayName = "SearchResultHeader";
